import { fromJS } from 'immutable';

// Constants
import { CONSTANTS } from './constants';
import { smartTrainingPeriod } from '../../constants/index';

// Others
import { strings } from '../../localization';

const initialState = fromJS({
    lang: process.env.APP_CONFIG.APP_LANGUAGE || 'en',
    availableLanguages: strings.getAvailableLanguages(),
    invitationAccepted: null,
    savedPreferences: {},
    smartTraining: {
        period: {
            from: smartTrainingPeriod.periodLength - 24, // 24 hours
            to: smartTrainingPeriod.periodLength
        },
        filteredDevice: -2
    },
    showDeletedRecords: true,
    preSelectedPeriod: {
       period: 10,
       from: 0,
       to: 0
    }
});

const reducer = (state = initialState, { type, payload }) => {
    let result;
    switch (type) {
        case CONSTANTS.ON_LANGAGE_CHANGE:
            result = state.set('lang', payload.lang);
            return result;

        case CONSTANTS.ON_SHOW_DELETED_RECORDS:
            return state.set('showDeletedRecords', payload.show);

        case CONSTANTS.ON_INVITATION_ACCEPTED:
            return state.set('invitationAccepted', payload.invitationAccepted);

        case CONSTANTS.ON_SAVED_PREFERENCES_PRESELECTED_METER:
            return state.setIn(['savedPreferences', `user_${payload.userId}`, 'preselectedMeterId'], payload.id);

        case CONSTANTS.ON_SAVED_PREFERENCES_PRESELECTED_DEVICE:
            return state.setIn(['savedPreferences', `user_${payload.userId}`, 'preselectedDeviceId'], payload.id);

        case CONSTANTS.ON_SAVED_PREFERENCES_PRESELECTED_PERIOD:
            return state.setIn(['savedPreferences', `user_${payload.userId}`, 'preselectedPeriodId'], payload.id);

        case CONSTANTS.ON_SAVED_PREFERENCES_PRESELECTED_GROUP_BY:
            return state.setIn(['savedPreferences', `user_${payload.userId}`, 'preselectedGroupById'], payload.id);

        case CONSTANTS.ON_SAVED_PREFERENCES_PRESELECTED_REFRESH:
            return state.setIn(['savedPreferences', `user_${payload.userId}`, 'preselectedRefresh'], payload.id);

        case CONSTANTS.ON_SAVED_PREFERENCES_LEGENDS_VISIBILITY:
            return state.setIn(['savedPreferences', `user_${payload.userId}`, 'legendsVisibility'], payload.visibility);

        case CONSTANTS.ON_SET_SMART_TRAINING_PERIOD:
            return state
                .setIn(['smartTraining', 'period', 'from'], payload.from)
                .setIn(['smartTraining', 'period', 'to'], payload.to);

        case CONSTANTS.ON_SET_SMART_TRAINING_MIN_WH:
            return state
                .setIn(['smartTraining', 'minWh'], payload.minWh);

        case CONSTANTS.ON_SET_DEVICE_FILTER:
            return state
                .setIn(['smartTraining', 'filteredDevice'], payload.filter);

        case CONSTANTS.ON_PRE_SELECTED_PERIOD_CHANGE:
            return state
                .setIn(['preSelectedPeriod', 'period'], payload.period.period)
                .setIn(['preSelectedPeriod', 'from'], payload.period.from)
                .setIn(['preSelectedPeriod', 'to'], payload.period.to);

        case CONSTANTS.ON_SAVED_SELECTED_METER_IDS:
            return state.setIn(['savedPreferences', `user_${payload.userId}`, 'selectedMeterIds'], payload.ids.join(','));

        case CONSTANTS.ON_SAVED_ENERGY_FLOW_POSITION:
            return state.setIn(['savedPreferences', `user_${payload.userId}`, 'energyFlowPosition'], payload.position);

        case CONSTANTS.ON_SAVED_CHART_MODE:
            return state.setIn(['savedPreferences', `user_${payload.userId}`, 'chartMode'], payload.chartMode);

        default:
            return state;
    }
};

export default reducer;
